module.exports = __webpack_public_path__ + "static/media/kids.57d0667f.jpg";